angular.module('manufacturing')
    .controller('ManufacturingOrderShowController', function ($scope, $rootScope, $uibModalInstance, ManufacturingOrder, data, ManufacturingOrderService, Principal, VehicleLocation, Client, ManufacturingOrderRealisation) {
        this.ManufacturingOrderService = ManufacturingOrderService
        this.$onInit = () => {
            ManufacturingOrder.get({id: data.id}).$promise.then(item => {
                this.item = item
                this.isOpen = !['COMPLETED', 'CANCELLED'].includes(item.status)
                this.loadVehicleLocation(this.item.location.id)
                this.loadClient(this.item.client.id)
                this.loadRealisations(this.item.id)
            })
        }

        this.loadVehicleLocation = (locationId) => {
            Principal.currentUser().then(user => {
                VehicleLocation.get({id: locationId}).$promise
                    .then(item => {
                        this.isUser = item.users.some(u => u.id === user.id)
                        this.isManager = item.managers.some(u => u.id === user.id)
                    })
            })
        }

        this.loadRealisations = (orderId) => {
            ManufacturingOrderRealisation.query({orderId: orderId}).$promise
                .then(items => {
                    let realisations = items.reduce((acc, realisation) => {
                        if (!acc[realisation.node.id]) {
                            acc[realisation.node.id] = {node: realisation.node, quantity: 0};
                        }
                        acc[realisation.node.id].quantity += realisation.quantity;
                        return acc;
                    }, {});
                    this.realisations = Object.values(realisations).sort((a, b) =>
                        a.node.name.localeCompare(b.node.name)
                    );
                });
        }

        this.loadClient = (clientId) => {
            if (clientId == null){
                this.client = null
                return
            }

            Client.get({id: clientId}).$promise.then(client => this.client = client);
        }

        this.canProcessQuantity = () => {
            let statusValid = ["IN_PROGRESS"].includes(this.item.status)
            let transportValid = this.item.transportAcceptance == null || this.item.transportAcceptance.status === "ACCEPTED"
            let locationValid = this.item.locationAcceptance == null || this.item.locationAcceptance.status === "ACCEPTED"
            return statusValid && transportValid && locationValid && (this.isUser || this.isManager)
        }

        this.canSeeRealisationHistory = () => {
            return this.realisations != null && Object.keys(this.realisations).length > 0 && (this.isUser || this.isManager)
        }

        this.joinStrings = (stringsArray, delimiter) => {
            stringsArray = stringsArray || [];
            const stringsFiltered = stringsArray
                .filter(it => it != null)
                .filter(it => it.length > 0);
            return stringsFiltered.join(delimiter);
        };

        this.cancel = () => $uibModalInstance.dismiss('cancel')
        $scope.$on('manufacturing-order.updated', () => this.$onInit())
        $scope.$on('manufacturing-order.deleted', () => this.cancel())
    })
